<template>
  <div>
    <h1>Nova de Categoria</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("categorias", ["categoria"]),
  },
  methods: {
    ...mapActions("categorias", ["ActionNewCategoria"]),
    loadData(id) {
      this.$router.push({ name: "categorias_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewCategoria();
  },
};
</script>

<style></style>
